import Button from 'components/inputs/Button';
import TextButton from 'components/inputs/TextButton';
import useHasAccessToRoutePlanApply, {
  NO_ROUTE_PLAN_APPLY_ACCESS_TITLE,
} from 'hooks/useHasAccessToRoutePlanApply';
import React from 'react';
import styled from 'styled-components';
import { ApplySummary } from './selection-helpers';

const Wrapper = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 16px;
  background: #fff;
  border-top: 2px solid rgb(204, 102, 51);
  box-shadow: 0 -3px 4px 1px rgb(0 0 0 / 10%);
`;

const Summary = styled.span`
  font-weight: 700;
`;

const Note = styled.span`
  color: rgb(120, 120, 120);
  font-size: 0.9em;
`;

const Right = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 14px;
`;

interface Props {
  summary: ApplySummary;
  isApplying: boolean;
  onDeselectAll: () => void;
  onApply: () => void;
}

const ApplyBar: React.FC<Props> = ({ summary, isApplying, onDeselectAll, onApply }) => {
  // Utan skrivbehörighet (GlobalSettingEnum 106) syns knappen men går inte att trycka på.
  // Planering, förhandsvisning och markering fungerar som vanligt.
  const canApply = useHasAccessToRoutePlanApply();

  const parts: string[] = [
    `${summary.packageCount} paket`,
    ...(summary.assignmentRequestCount > 0
      ? [
          `${summary.assignmentRequestCount} annonsförfråg${
            summary.assignmentRequestCount === 1 ? 'an' : 'ningar'
          }`,
        ]
      : []),
    ...(summary.personalTransportCount > 0
      ? [
          `${summary.personalTransportCount} personlig${
            summary.personalTransportCount === 1 ? '' : 'a'
          } transport${summary.personalTransportCount === 1 ? '' : 'er'}`,
        ]
      : []),
    `${summary.assignmentCount} uppdrag`,
  ];

  return (
    <Wrapper>
      <Summary>{parts.join(' · ')}</Summary>
      <Note>Uppdrag sätts till Planerad — utskick sker separat</Note>
      <Right>
        <TextButton disabled={isApplying} onClick={onDeselectAll} type="button">
          Avmarkera alla
        </TextButton>
        {/* Titeln sitter på ett omslag: en avstängd knapp får inga mushändelser, och då visar
            inte alla webbläsare dess tooltip. */}
        <span title={canApply ? undefined : NO_ROUTE_PLAN_APPLY_ACCESS_TITLE}>
          <Button
            disabled={!canApply || isApplying || summary.packageCount === 0}
            onClick={onApply}
            type="button"
          >
            {isApplying ? 'Verkställer…' : `Verkställ (${summary.packageCount})`}
          </Button>
        </span>
      </Right>
    </Wrapper>
  );
};

export default ApplyBar;
